module.exports = __webpack_public_path__ + "static/media/microscopy-nsit0108-01 2.2753b8aa.png";